export default __webpack_public_path__ + "static/media/pindown4.1e054ee5.png";